module.exports = __webpack_public_path__ + "media/images/dime-logo-e2448ebc65d03c40b18c2ba9119ad023.svg";